import { map } from 'lodash'
import { AccountTypeEnum } from '../../types/AccountTypeEnum'
import { tradeTypeEnumToDisplay } from './helpers/tradeTypeDisplay' //TODO AP might have a circular dependency since simplifying this import breaks 2 test suites
import {
  Capacity,
  CapacityEnum,
  Currency,
  CurrencyEnum,
  ExecutionAlgorithmDisplay,
  ExecutionAlgorithmEnum,
  InstrumentType,
  InstrumentTypeEnum,
  listingCountryEnum,
  listingCountryType,
  MarketDisplay,
  MarketEnum,
  RouteTypeEnum,
  SecurityCodeType,
  SecurityCodeTypeEnum,
  SettlementType,
  SettlementTypeEnum,
  SpecialInstructionsEnum,
  TradeActionEnum,
  TradeType,
  TradeTypeEnum,
} from './Types'

export enum TradeActionScenario {
  ShortAccountTypeNonOptionInstrumentType,
  OptionInstrumentType,
  NotShortAccountTypeNonOptionInstrumentType,
}

export const TradeActionOptions = {
  [TradeActionScenario.ShortAccountTypeNonOptionInstrumentType]: [
    { value: TradeActionEnum.BuyToCover, text: 'Buy to Cover' },
    { value: TradeActionEnum.ShortSell, text: 'Short Sell' },
  ],
  [TradeActionScenario.OptionInstrumentType]: [
    { value: TradeActionEnum.SellToOpen, text: 'Sell To Open' },
    { value: TradeActionEnum.SellToClose, text: 'Sell To Close' },
    { value: TradeActionEnum.BuyToOpen, text: 'Buy To Open' },
    { value: TradeActionEnum.BuyToClose, text: 'Buy To Close' },
  ],
  [TradeActionScenario.NotShortAccountTypeNonOptionInstrumentType]: [
    { value: TradeActionEnum.Buy, text: 'Buy' },
    { value: TradeActionEnum.Sell, text: 'Sell' },
  ],
}

export const securityCodeTypeOptions: SecurityCodeType[] = [
  { value: SecurityCodeTypeEnum.tickerSymbol, text: SecurityCodeTypeEnum.tickerSymbol },
  { value: SecurityCodeTypeEnum.cusip, text: SecurityCodeTypeEnum.cusip },
  { value: SecurityCodeTypeEnum.isin, text: SecurityCodeTypeEnum.isin },
  { value: SecurityCodeTypeEnum.occSymbol, text: SecurityCodeTypeEnum.occSymbol },
  { value: SecurityCodeTypeEnum.sedol, text: SecurityCodeTypeEnum.sedol },
]

export const capacityOptions: Capacity[] = [
  { value: CapacityEnum.agent, text: CapacityEnum.agent },
  { value: CapacityEnum.mixed, text: CapacityEnum.mixed },
  { value: CapacityEnum.principle, text: CapacityEnum.principle },
]

export const InstrumentTypeOptions: InstrumentType[] = [
  { value: InstrumentTypeEnum.equity, text: InstrumentTypeEnum.equity },
  { value: InstrumentTypeEnum.option, text: InstrumentTypeEnum.option },
]

export const TradeTypeOptions: TradeType[] = [
  { value: TradeTypeEnum.allocation, text: tradeTypeEnumToDisplay(TradeTypeEnum.allocation) },
  { value: TradeTypeEnum.execution, text: tradeTypeEnumToDisplay(TradeTypeEnum.execution) },
  { value: TradeTypeEnum.awayTrade, text: tradeTypeEnumToDisplay(TradeTypeEnum.awayTrade) },
]

export const CurrencyOptions: Currency[] = [
  { value: CurrencyEnum.usd, text: CurrencyEnum.usd },
  { value: CurrencyEnum.cad, text: CurrencyEnum.cad },
]

export const SettlementTypeOptions: SettlementType[] = [
  { value: SettlementTypeEnum.regularSettlement, text: SettlementTypeEnum.regularSettlement },
  { value: SettlementTypeEnum.specialSettlement, text: SettlementTypeEnum.specialSettlement },
]

export const RouteTypeOptions = [
  { value: RouteTypeEnum.Algo, text: RouteTypeEnum.Algo },
  { value: RouteTypeEnum.Away, text: RouteTypeEnum.Away },
  { value: RouteTypeEnum.Corr, text: RouteTypeEnum.Corr },
  { value: RouteTypeEnum.Dma, text: RouteTypeEnum.Dma },
  { value: RouteTypeEnum.Mngd, text: RouteTypeEnum.Mngd },
  { value: RouteTypeEnum.Quik, text: RouteTypeEnum.Quik },
]

export const RouteTypeOptionsApexTrade = [
  { value: RouteTypeEnum.Dma, text: RouteTypeEnum.Dma },
  { value: RouteTypeEnum.Mngd, text: RouteTypeEnum.Mngd },
  { value: RouteTypeEnum.Quik, text: RouteTypeEnum.Quik },
  { value: RouteTypeEnum.Algo, text: RouteTypeEnum.Algo },
]

export const RouteTypeOptionsAwayTrade = [
  { value: RouteTypeEnum.Away, text: RouteTypeEnum.Away },
  { value: RouteTypeEnum.Corr, text: RouteTypeEnum.Corr },
]

export const MarketOptions = map(MarketEnum, value => ({
  key: value,
  value: value,
  text: MarketDisplay[value],
}))

export const ExecutionAlgoOptions = map(ExecutionAlgorithmEnum, value => ({
  key: value,
  value: value,
  text: ExecutionAlgorithmDisplay[value],
}))

export const SpecialInstructionDisplay = {
  [SpecialInstructionsEnum.RULE_144]: 'RULE_144 - Rule 144 REG SHO transaction',
  [SpecialInstructionsEnum.WITH_DIVIDEND]: 'WITH_DIVIDEND - With dividend',
  [SpecialInstructionsEnum.WITH_RIGHTS]: 'WITH_RIGHTS - With rights',
  [SpecialInstructionsEnum.CLOSE_CONTRACT]: 'CLOSE_CONTRACT - Closing contract',
  [SpecialInstructionsEnum.COVER_SHORT]: 'COVER_SHORT - Cover short',
  [SpecialInstructionsEnum.CROSS_TRADE]: 'CROSS_TRADE - Crossed trade',
  [SpecialInstructionsEnum.OPEN_CONTRACT_COVERED]: 'OPEN_CONTRACT_COVERED - Open contract covered',
  [SpecialInstructionsEnum.DISCRETION_EXERCISED]: 'DISCRETION_EXERCISED - Discretion is exercised',
  [SpecialInstructionsEnum.DISCRETION_NOT_EXERCISED]: 'DISCRETION_NOT_EXERCISED - Discretion not exercised',
  [SpecialInstructionsEnum.WHEN_DISTRIBUTED]: 'WHEN_DISTRIBUTED - When distributed',
  [SpecialInstructionsEnum.OPTION_ASSIGNMENT]: 'OPTION_ASSIGNMENT - Option assignments',
  [SpecialInstructionsEnum.EMPLOYEE_STOCK_OPTION]: 'EMPLOYEE_STOCK_OPTION - Employee stock option',
  [SpecialInstructionsEnum.INVESTMENT_BANKING]: 'INVESTMENT_BANKING - Investment banking',
  [SpecialInstructionsEnum.BROKER_DEALER_ORDER]: 'BROKER_DEALER_ORDER - Broker/dealer order',
  [SpecialInstructionsEnum.MAKE_MARKET_IN_SECURITY]: 'MAKE_MARKET_IN_SECURITY - We make a market in this security.',
  [SpecialInstructionsEnum.MAKE_MARKET_SOLICITED]: 'MAKE_MARKET_SOLICITED - We make a market - Solicited',
  [SpecialInstructionsEnum.MAKE_MARKET_UNSOLICITED]: 'MAKE_MARKET_UNSOLICITED - We make a market - Unsolicited',
  [SpecialInstructionsEnum.CUSTOMER_DIRECTED]: 'CUSTOMER_DIRECTED',
  [SpecialInstructionsEnum.FULLY_REGISTERED]: 'FULLY_REGISTERED - Fully registered',
  [SpecialInstructionsEnum.OPEN_CONTRACT]: 'OPEN_CONTRACT - Open contract',
  [SpecialInstructionsEnum.ODDLOT_DIFF_ON_REQUEST]: 'ODDLOT_DIFF_ON_REQUEST - Oddlot differential on request',
  [SpecialInstructionsEnum.PROSPECTUS_ENCLOSED]: 'PROSPECTUS_ENCLOSED - Prospectus enclosed',
  [SpecialInstructionsEnum.PROSPECTUS_SEPARATE_MAIL]: 'PROSPECTUS_SEPARATE_MAIL - Prospectus under separate mail',
  [SpecialInstructionsEnum.SHORT]: 'SHORT - Short',
  [SpecialInstructionsEnum.SOLICITED]: 'SOLICITED - Solicited',
  [SpecialInstructionsEnum.UNSOLICITED]: 'UNSOLICITED - Unsolicited',
  [SpecialInstructionsEnum.X_DIVIDEND]: 'X_DIVIDEND - X-dividend',
}

export const SpecialInstructionOptions = map(SpecialInstructionsEnum, value => ({
  key: value,
  value: value,
  text: SpecialInstructionDisplay[value],
}))

export const SourceAccountTypeOptions = [
  { value: AccountTypeEnum.Cash, text: AccountTypeEnum.Cash },
  { value: AccountTypeEnum.Margin, text: AccountTypeEnum.Margin },
  { value: AccountTypeEnum.Dvp, text: AccountTypeEnum.Dvp },
  { value: AccountTypeEnum.Short, text: AccountTypeEnum.Short },
]
export const ListingCountryTypeOptions: listingCountryType[] = [
  { value: listingCountryEnum.UnitedStates, text: 'United States' },
  { value: listingCountryEnum.Canada, text: 'Canada' },
]

export const ValidationSymbolMaxLength = {
  [SecurityCodeTypeEnum.tickerSymbol]: 7,
  [SecurityCodeTypeEnum.cusip]: 9,
  [SecurityCodeTypeEnum.isin]: 12,
  [SecurityCodeTypeEnum.occSymbol]: 21,
  [SecurityCodeTypeEnum.sedol]: 7,
}

export const ValidationLength = {
  quantityInteger: 12,
  quantityDecimal: 4,
  executionPriceInteger: 8,
  executionPriceDecimal: 7,
  memo: 20,
  orderIdInteger: 32,
  executingBroker: 4,
  feeInteger: 11,
  feeDecimal: 2,
  lotMatchingQuantityInteger: 12,
  lotMatchingQuantityDecimal: 5,
  lotMatchingPriceInteger: 8,
  lotMatchingPriceDecimal: 8,
}

export const ANIMATION_DURATION = 400

export const helpText = {
  symbol:
    'Do not use special characters. When applicable, remove periods or slashes and replace them with a space (e.g. BRK.B should be submitted as BRK B).',
  principalAmount: 'Estimated principal prior to charges and fees',
  netAmount: 'Estimated amount prior to regulatory and other system applied fees',
  buyingPower: 'Buying power is based on start of day data and provided for informational purposes only.',
  commission: 'Positive is a debt to the customer. Negative is a credit to the customer.',
  markUpMarkDown: 'Positive is a mark-up on transaction price. Negative is a mark-down on transaction price.',
}

export const DEFAULT_ORDER_ID = '345'
